import React, { useState } from "react";
import "./PopupBildOverlay.css";
import MaterialIcon from "../MaterialIcon/MaterialIcon";

const PopupBildOverlay = ({ imageUrl, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300); // Match the animation duration
  };

  const handleOverlayClick = () => {
    handleClose();
  };

  const handleImageClick = (e) => {
    // Prevent closing when clicking on the image itself
    e.stopPropagation();
  };

  return (
    <div
      className={`PopupBildOverlay${isClosing ? " closing" : ""}`}
      onClick={handleOverlayClick}
    >
      <div className="imageContainer" onClick={handleImageClick}>
        <img src={imageUrl} alt="Popup" />
        <button className="closeButton" onClick={handleClose}>
          <MaterialIcon name="close" small />
        </button>
      </div>
    </div>
  );
};

export default PopupBildOverlay;
